import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTE_PATHS } from '../../utils/route-paths.const';

/**
 * Guards /investment-success.
 * - Allows entry only when `state: { investmentSuccess: true }` is present
 *   (set by the investment component after the investment POST succeeds).
 * - If the user is already inside the app and somehow triggers a navigation
 *   here, they stay on their current URL.
 * - A cold direct-URL visit with no prior navigation falls back to HOME.
 */
export const investmentSuccessGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const nav = router.currentNavigation();

  if (nav?.extras.state?.['investmentSuccess'] === true) return true;

  const hasPriorNav = nav?.previousNavigation != null;
  if (hasPriorNav) {
    router.navigateByUrl(router.url, {
      replaceUrl: true,
      state: { bypassGuard: true },
    });
  } else {
    router.navigate([ROUTE_PATHS.HOME], {
      replaceUrl: true,
      state: { bypassGuard: true },
    });
  }
  return false;
};
